import { Instance } from 'mobx-state-tree';
import { TeamMemberCreatedDtoModelBase } from './TeamMemberCreatedDtoModel.base';

/* The TypeScript type of an instance of TeamMemberCreatedDtoModel */
export interface TeamMemberCreatedDtoModelType extends Instance<typeof TeamMemberCreatedDtoModel.Type> {}

/* A graphql query fragment builders for TeamMemberCreatedDtoModel */
export { selectFromTeamMemberCreatedDto, teamMemberCreatedDtoModelPrimitives, TeamMemberCreatedDtoModelSelector } from './TeamMemberCreatedDtoModel.base';

/**
 * TeamMemberCreatedDtoModel
 */
export const TeamMemberCreatedDtoModel = TeamMemberCreatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
